import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from '../ui/button2';
import { View } from '../common/View';

import { RenderMonths } from './RenderMonths';

type IncomeHeaderProps = {
  MonthComponent?: () => JSX.Element;
  onShowNewGroup: () => void;
  showAddGroup?: boolean;
};

export function IncomeHeader({
  MonthComponent,
  onShowNewGroup,
  showAddGroup = true,
}: IncomeHeaderProps) {
  return (
    <View
      style={{
        flexDirection: 'row',
        flexShrink: 0,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        borderBottom: '1px solid var(--color-tableBorder)',
      }}
    >
      <View
        className="text-[var(--color-pageTextLight)]"
        style={{
          width: 200,
          justifyContent: 'center',
          paddingLeft: 15,
          paddingRight: 5,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          userSelect: 'none',
          WebkitUserSelect: 'none',
        }}
      >
        {showAddGroup ? (
          <Button onClick={onShowNewGroup} style={{ fontSize: 12, margin: 10 }}>
            <Trans>Add group</Trans>
          </Button>
        ) : (
          <View style={{ flexGrow: 1 }}>
            <Trans>Income</Trans>
          </View>
        )}
      </View>
      <RenderMonths component={MonthComponent} />
    </View>
  );
}